module.exports = __webpack_public_path__ + "static/media/logos_squares_Gold_KONE.f41c81e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Gold_KONE.png
// module id = 84
// module chunks = 0